import { Text } from '@digibee/beehive-ui';
import { iff } from '@digibee/control-statements';
import { Accordion, AccordionItem } from '@heroui/react';
import { Copy } from 'iconoir-react';
import map from 'lodash/map';
import { FC, Fragment } from 'react';

import * as Elements from './TriggerDetails.Elements';

import { CopyToClipboard } from '~/components/CopyToClipboard';
import TextNative from '~/components/Text';

interface TriggerDetailsProps {
  source: {
    label: string;
    value: string;
  }[];
  triggers: {
    key: string;
    value: string;
  }[];
  title: string;
}

const TriggerDetails: FC<TriggerDetailsProps> = ({
  source = [],
  title,
  triggers = []
}) => (
  <Accordion>
    <AccordionItem title={title}>
      {iff(triggers.length > 0, () => (
        <Elements.EndpointSeparator>
          {map(triggers, item => (
            <Elements.ContainerEndpoint key={crypto.randomUUID()}>
              <Elements.EndPoint>
                <TextNative size='sm' weight='medium' align='left'>
                  {item.key}:
                </TextNative>
                <Elements.EndPointText size='sm' align='left'>
                  {item.value}
                </Elements.EndPointText>
              </Elements.EndPoint>
              <CopyToClipboard text={item.value}>
                <Copy className='icon-smallest' />
              </CopyToClipboard>
            </Elements.ContainerEndpoint>
          ))}
        </Elements.EndpointSeparator>
      ))}
      <Elements.Container>
        {map(source, item => (
          <Fragment key={crypto.randomUUID()}>
            <Elements.Row title={item.value}>
              <Text css={{ width: '98%' }}>{item.label}</Text>
              <Text css={{ width: '98%' }}>{item.value}</Text>
            </Elements.Row>
            <Elements.Separator />
          </Fragment>
        ))}
      </Elements.Container>
    </AccordionItem>
  </Accordion>
);

export default TriggerDetails;
